import { render } from "./g-simple-page.vue?vue&type=template&id=44377e86&ts=true"
import script from "./g-simple-page.vue?vue&type=script&lang=tsx"
export * from "./g-simple-page.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__